import { render, staticRenderFns } from "./MessageInput.vue?vue&type=template&id=08849b93&scoped=true&"
import script from "./MessageInput.vue?vue&type=script&lang=ts&"
export * from "./MessageInput.vue?vue&type=script&lang=ts&"
import style0 from "./MessageInput.vue?vue&type=style&index=0&id=08849b93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08849b93",
  null
  
)

export default component.exports